/**
 * Created by contrapro on 2018/4/16
 */

import React from 'react';
import { Component } from "react";
import { connect } from 'react-redux';
import './HomeView.css';
import { VIEW_STATE, getWishPanelTitle, MAX_WISH_NUM } from '../../../util/constConfig';
import { updateViewState, onShareOK, toggleSharePanel } from "../../../actions";
import { updateJSSDK } from "../../../util/wxUtil";
import { getJSSDKSignConfigHost, getStaticHost } from '../../../util/serverUtil';

import btn1 from '../../../assets/imgs/home_btn1.png';
import btn2 from '../../../assets/imgs/home_btn2.png';

class HomeView extends Component {

    constructor(props) {
        super(props);

        this.onUpload = this.onUpload.bind(this);
        this.onHowto = this.onHowto.bind(this);

        // this.onShareCancel = this.onShareCancel.bind(this);
        // this.onShareAppOK = this.onShareAppOK.bind(this);
        // this.onShareTimelineOK = this.onShareTimelineOK.bind(this);
        // this.onShareQQOK = this.onShareQQOK.bind(this);
        // this.onShareWeiboOK = this.onShareWeiboOK.bind(this);

        // this.makeVioSatisfy = this.makeVioSatisfy.bind(this);

    }

    componentDidMount() {


        //
        // // const link = encodeURI(getStaticHost() + "/wishShare/index.html");
        // const link = encodeURI(getStaticHost() + "/?share=wish"); //TODO 先用一个客户端，开发简单一些。
        // const imgUrl = getStaticHost() + '/logo28.png';
        // const title = '我向K11许了一个愿，来帮我助力吧!';
        // const desc = 'K11沈阳许愿池';
        // const app = this.onShareAppOK;
        // const time = this.onShareTimelineOK;
        // const weibo = this.onShareWeiboOK;
        // const qq = this.onShareQQOK;
        // const cancel = this.onShareCancel;
        // setTimeout( ()=> {
        //     updateJSSDK(//linkUrl, imgUrl, title, desc, app, time, weibo, qq, cancelCB
        //         link, imgUrl, title, desc, app, time, weibo, qq, cancel
        //     );
        //
        //     // console.log('vio shareData', this.makeVioSatisfy());
        //
        // }, 800);
    }

    onUpload() {
        console.log('onUpload');
        this.props.updateViewState(VIEW_STATE.SCAN);

    }

    onHowto() {
        console.log('onHowto');
        this.props.updateViewState(VIEW_STATE.HOWTO);
    }


    onShareCancel() {
        //console.log('onShareCancel');
        // alert('onShareCancel');
    }

    // makeVioSatisfy() {
    //     //vio有bug，不能动态，只能在调用wx api时写死.
    //     const linkUrl = encodeURI(getStaticHost() + "/ufshare/?userID=" + this.props.userReducer.objectId
    //         + "&nickname=" + this.props.userReducer.nickname);
    //     const imgUrl = getStaticHost() + '/shareLogo.jpg';
    //     return {
    //         title: '快来光谷K11都市农庄领取种子吧!',
    //         desc: '立刻开始种植～ 植物成熟后将有机会领取惊喜奖品!',
    //         link: linkUrl,
    //         imgUrl: imgUrl,
    //         type: 'link',
    //         dataUrl: '',
    //         success: ()=>{},
    //         cancel:()=>{}
    //     }
    // };

    // onShareAppOK() {
    //     console.log('onShareAppOK');
    //     // alert('onShareAppOK');
    //     this.props.onShareOK();
    //
    //     //TODO 似乎也没必要，页面加载的时候调用过一次，之后的是为了分享调整，不需要这个。
    //     // console.log('_vio.push(["_share","talk" .....');
    //     // window._vio.push(["_share","talk", this.makeVioSatisfy()]);
    //     window.mixpanel.track("share", {
    //         'name': 'talk'
    //     });
    // }
    //
    // onShareTimelineOK() {
    //     console.log('onShareTimelineOK');
    //     // alert('onShareTimelineOK');
    //     this.props.onShareOK();
    //     //TODO 似乎也没必要，页面加载的时候调用过一次，之后的是为了分享调整，不需要这个。
    //     // console.log('_vio.push(["_share","wechat" .....');
    //     // window._vio.push(["_share","wechat", this.makeVioSatisfy()]);
    //     window.mixpanel.track("share", {
    //         'name': 'wechat'
    //     });
    // }
    //
    // onShareWeiboOK() {
    //     console.log('onShareWeiboOK');
    //     // alert('onShareTimelineOK');
    //     this.props.onShareOK();
    //     //TODO 似乎也没必要，页面加载的时候调用过一次，之后的是为了分享调整，不需要这个。
    //     // console.log('window._vio.push(["_share","weibo" .....');
    //     // window._vio.push(["_share","weibo", this.makeVioSatisfy()]);
    //     window.mixpanel.track("share", {
    //         'name': 'weibo'
    //     });
    // }
    //
    // onShareQQOK() {
    //     console.log('onShareQQOK');
    //     // alert('onShareWeiboOK');
    //     this.props.onShareOK();
    //     //TODO 似乎也没必要，页面加载的时候调用过一次，之后的是为了分享调整，不需要这个。
    //     // console.log('window._vio.push(["_share","qq" .....');
    //     // window._vio.push(["_share","qq", this.makeVioSatisfy()]);
    //     window.mixpanel.track("share", {
    //         'name': 'qq'
    //     });
    // }


    render() {
        return (
            <div className="HomeView">
                    <img className="HomeView-btn1" alt="" src={btn1} onClick={this.onUpload} />
                    <img className="HomeView-btn2" alt="" src={btn2} onClick={this.onHowto} />
            </div>
        );
    }
}


export default connect(state => ({
        viewState: state.viewStateReducer.viewState,
    }),
    dispatch => ({
        updateViewState: (sceneData) => {
            dispatch(updateViewState(sceneData))
        },
        onShareOK: () => {
            // dispatch(authFail())
            dispatch(onShareOK())
        },
        toggleSharePanel: (visible) => {
            dispatch(toggleSharePanel(visible))
        }
    }))(HomeView)


// WEBPACK FOOTER //
// ./src/react/views/home/HomeView.js